import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js';
import { User } from '../interface/project/user';

const SECRET_KEY = '_0J=@p2r3:F-9M5k?ILKeZymTY8b61qf'; // 对称加密的强密钥

export const GLOBAL_NAMESPACE = 'tncet';
export const TOKEN = `${GLOBAL_NAMESPACE}_login_ticket`;
export const USER = `${GLOBAL_NAMESPACE}_user_meta`;
export const USER_ID = `${GLOBAL_NAMESPACE}_loginid`;
export const USER_UUID = `${GLOBAL_NAMESPACE}_uuid`;

class CookieStore {

    // 加密方法
    encrypt(value) {
        const iv = CryptoJS.lib.WordArray.random(16);
        const encrypted = CryptoJS.AES.encrypt(value.toString(), CryptoJS.enc.Utf8.parse(SECRET_KEY), {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
        });
        return iv.toString() + encrypted.toString();
    }

    // 解密方法
    decrypt(value) {
        const iv = CryptoJS.enc.Hex.parse(value.substr(0, 32));
        const encrypted = value.substr(32);
        const decrypted = CryptoJS.AES.decrypt(encrypted, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    set(key: string, value: any, crossDomain: boolean = true) {
        Cookies.set(key, JSON.stringify(value), {
            domain: !!crossDomain ? document.domain.split('.').slice(-2).join('.') : window.location.host,
        });
    }

    setExpires(key: string, value: any, expires: number, crossDomain: boolean = true) {
        Cookies.set(key, JSON.stringify(value), {
            domain: !!crossDomain ? document.domain.split('.').slice(-2).join('.') : window.location.host,
            expires: expires
        });
    }

    setUUID(uuid: string) {
        Cookies.set(USER_UUID, `${uuid}`, {
            domain: document.domain.split('.').slice(-2).join('.'),
            expires: 60
        })
    }

    getUUID() {
        return Cookies.get(USER_UUID) || null;
    }

    setUser(user: User) {
        this.setExpires(USER, user, 60);
    }

    getUser() {
        return this.get(USER);
    }

    get(key) {
        let value = Cookies.get(key);
        return JSON.parse(value || 'null') || null;
    }

    setToken(token: string) {
        Cookies.set(TOKEN, token, {
            domain: document.domain.split('.').slice(-2).join('.'),
            expires: 60
        })
    }

    getToken() {
        return Cookies.get(TOKEN);
    }

    setLoginId(id: number) {
        const encryptedId = this.encrypt(id);
        Cookies.set(USER_ID, encryptedId, {
            domain: document.domain.split('.').slice(-2).join('.'),
            expires: 60
        })
    }

    getLoginId() {
        const encryptedId = Cookies.get(USER_ID);
        if (!encryptedId) return null;
        return +this.decrypt(encryptedId);
    }

    clear() {
        let domain = document.domain.split('.').slice(-2).join('.');
        Cookies.remove(TOKEN,  {
            domain: domain,
        });
        Cookies.remove(USER_ID, {
            domain: domain,
        });
        Cookies.remove(USER, {
            domain: domain,
        });
        Cookies.remove(USER_UUID, {
            domain: domain,
        });
    }
}

export default new CookieStore();